import React from "react"
import Item from "./allowed-items-item"

const PopularItems = ({
  mostPopularHeadline,
  popularItems,
  setHash,
  scrollIntoView,
  mopinionScript,
  checkinLabel,
  handLuggageLabel,
  hash,
  ariaLabelAllowed,
  ariaLabelSometimesAllowed,
  ariaLabelNotAllowed,
}) => {
  return (
    <div className="most-popular-items">
      <div className="items-list-inner">
        <h2 className="items-headline">{mostPopularHeadline || "Mest Populære"}</h2>
        {popularItems.map((item, index) => {
          return (
            <Item
              key={item.category + "-" + index}
              item={item}
              setHash={setHash}
              checkinLabel={checkinLabel || "Indtjekket"}
              handLuggageLabel={handLuggageLabel || "Håndbagage"}
              scrollIntoView={scrollIntoView}
              hash={hash}
              mopinionScript={mopinionScript || null}
              ariaLabelAllowed={ariaLabelAllowed}
              ariaLabelSometimesAllowed={ariaLabelSometimesAllowed}
              ariaLabelNotAllowed={ariaLabelNotAllowed}
            />
          )
        })}
      </div>
    </div>
  )
}

export default PopularItems
